import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field, FieldArray, FormSection } from 'redux-form/immutable'
import { Form, FormField, Table } from 'semantic-ui-react'

import RenderAliquotasTributos from './RenderAliquotasTributos'

import { CRUDForm } from '../CRUD'
import { DatePickerInput } from '../FormComponents'
import { required, dateValidator } from '../../utils/validations'

function VigenciaTributoForm (props) {
  return (
    <CRUDForm
      title='Tributos'
      titleAs='h3'
      icon='calendar'
      padded={false}
      {...props}>
      <FormSection name='vigencia_tributo'>
        <Form.Group>
          <FormField width={3}>
            <label>Início da Vigência</label>
            <Field autoFocus
              name='starts_at'
              placeholder='Início da Vigência'
              validate={[required, dateValidator]}
              component={DatePickerInput}
              loading={props.loading}
            />
          </FormField>
        </Form.Group>
        <Form.Group>
          <Form.Field width={6}>
            <Table celled striped selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={4} textAlign='right'>Tributo</Table.HeaderCell>
                  <Table.HeaderCell width={2} textAlign='right'>Alíquota (%)</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <FieldArray
                name='aliquotas_tributos_attributes'
                component={RenderAliquotasTributos}
              />
            </Table>
          </Form.Field>
        </Form.Group>
      </FormSection>
    </CRUDForm>
  )
}

VigenciaTributoForm.propTypes = {
  loading: PropTypes.bool,
}

export default reduxForm({form: 'VigenciaTributoForm'})(VigenciaTributoForm)
